// extracted by mini-css-extract-plugin
export default {"backdrop":"Loading_backdrop__45Pma","loadingGif":"Loading_loadingGif__BCEDD"};